import {
  styled,
  TextField,
  IconButton,
  Paper,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Box,
  Tab,
  useMediaQuery,
  DialogActions,
  Button,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./gallery_details.css";
import { useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import SearchIcon from "@mui/icons-material/Search";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Event1 from "../../../images/event1.jpg";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import PinDropIcon from "@mui/icons-material/PinDrop";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import PPKMLogo from "../../../images/ppkmLogo.jpg";

import getEventController from "../Controller/getEvent_controller";
import SearchBar from "../../../components/SearchBox/searchbox.js";
import { Form } from "antd";

const GalleryDetails = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook
  const location = useLocation();
  const isLargeScreen = useMediaQuery("(min-width:640px)");
  const [form] = Form.useForm();

  const [spacing, setSpacing] = React.useState(2);

  const [open, setOpen] = React.useState(false);
  const [selectedImg, setSelectedImg] = React.useState(null);
  const { eventCategoryId } = location.state; // Access passed data
  // console.log(eventCategoryId);
  const [eventData, setEventData] = useState([]);
  const [filteredgalleryListData, setfilteredgalleryListData] = useState([]);

  useEffect(() => {
    getEventController
      .getEventbyEventCategories(eventCategoryId)
      .then((response) => {
        console.log("API Response:", response); // Debugging log

        if (Array.isArray(response)) {
          // Ensure response is an array
          setEventData(formatEvents(response));
        } else {
          console.error("API response is not an array:", response);
          setEventData([]); // Set empty array to prevent .map() errors
        }
      })
      .catch((error) => {
        console.error("Error fetching event:", error);
        setEventData([]); // Handle errors gracefully
      });
  }, []);

  const formatEvents = (events) => {
    return events.map((item) => {
      const isValidDate = (date) =>
        date && date !== "0000-00-00" && !isNaN(new Date(date).getTime());

      const startDate = isValidDate(item.event_start_date)
        ? new Date(item.event_start_date)
        : null;
      const endDate = isValidDate(item.event_end_date)
        ? new Date(item.event_end_date)
        : null;

      const dateFormatter = new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

      // ✅ Extract year from event_start_date
      const eventYear = startDate ? startDate.getFullYear() : "Unknown";

      // ✅ Extract first image from file_names (comma-separated)
      const firstImage = item.file_names ? item.file_names.split(",")[0] : null;

      return {
        id: item.eventID,
        event_categoryID: item.event_categoryID,
        imgSrc:
          firstImage && item.base_url
            ? `${item.base_url}/${firstImage.trim()}`
            : null, // Construct full image URL,
        title: item.event_name || "Untitled Event",
        startdate: startDate
          ? dateFormatter.format(startDate)
          : "Date not available",
        enddate: endDate ? dateFormatter.format(endDate) : "",
        venue: item.event_venue || "Venue not specified",
        category: item.event_category_name || "Untitled Category",
        base_url: item.base_url,
        file_names: item.file_names,
        year: eventYear,
      };
    });
  };

  const groupEventsByYear = (events) => {
    return events.reduce((acc, event) => {
      if (!acc[event.year]) {
        acc[event.year] = [];
      }
      acc[event.year].push(event);
      return acc;
    }, {});
  };

  const groupedEvents =
    eventCategoryId === 10 ? groupEventsByYear(eventData) : null;

  const [expandedYear, setExpandedYear] = useState(null);

  const handleExpandYear = (year) => {
    setExpandedYear((prev) => (prev === year ? null : year)); // Toggle expansion
  };

  const handleEventClick = (eventId, title) => {
    navigate("/event_gallery", { state: { eventId, title } }); // Update the state without changing the URL(post eventID and Event Title)
  };

  const handleClickOpen = (img) => {
    setSelectedImg(img);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImg(null);
  };

  const handleSearch = (searchTerm) => {
    if (!searchTerm) {
      setfilteredgalleryListData(eventData);
    } else {
      const lowercasedTerm = searchTerm.toLowerCase();

      const filtered = eventData.filter((event) =>
        (event.title?.toLowerCase() ?? "").includes(lowercasedTerm)
      );

      // console.log("Filtered result:", filtered); // ← this helps debug

      setfilteredgalleryListData(filtered);
    }
  };

  useEffect(() => {
    setfilteredgalleryListData(eventData);
  }, [eventData]);
  // Sample events array with image and title data
  const galleries = [];

  const itemData = [];

  return (
    <React.Fragment>
      {!isLargeScreen ? (
        <div className="gallery-list">
          <div>
            <ImageList
              cols={3}
              sx={{
                padding: "20px",
              }}
            >
              {itemData.map((item) => (
                <ImageListItem
                  key={item.img}
                  onClick={() => handleClickOpen(item.img)}
                >
                  <img
                    srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                    src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
                    alt={item.title}
                    loading="lazy"
                    style={{ cursor: "pointer" }}
                  />
                </ImageListItem>
              ))}
            </ImageList>

            {/* Dialog to show the enlarged image */}
            <Dialog open={open} onClose={handleClose} maxWidth="lg">
              <DialogContent>
                <img
                  src={selectedImg}
                  alt="Enlarged"
                  style={{ width: "100%", height: "auto" }}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Close</Button>
                {/* Download Button */}
                <Button
                  component="a"
                  href={selectedImg}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  color="primary"
                  variant="contained"
                >
                  Download
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </div>
      ) : (
        <div className="gallery-list">
          {/* back button */}
          <div>
            <ArrowBackIosIcon
              className="logo"
              onClick={() => navigate(-1)}
              label="BACK"
            />
            <b>RETURN TO CATEGORY SELECTION</b>
          </div>
          {/* event selection */}
          <div>
            <span
              style={{
                display: "flex",
                justifyContent: "center",
                fontSize: "25px",
                fontWeight: "bold",
              }}
            >
              EVENT SELECTION
            </span>
          </div>
          <div>
            {/* Search Bar */}
            <SearchBar onSearch={handleSearch} />

            {/* Event List */}
            <Box sx={{ width: "100%", typography: "body1" }}>
              {eventCategoryId === 10 ? (
                Object.keys(groupedEvents)
                  .map(Number) // Convert keys to numbers (because keys are strings by default)
                  .sort((a, b) => b - a) // Sort years in descending order
                  .map((year) => (
                    <Paper
                      key={year}
                      sx={{
                        width: "90%",
                        margin: "20px auto",
                        padding: "10px",
                        backgroundColor: "#f9f9f9",
                        borderRadius: "10px",
                        boxShadow: 4,
                        cursor: "pointer",
                        transition: "0.3s",
                        "&:hover": { boxShadow: 8 },
                      }}
                    >
                      {/* 🔹 Year Header (Expandable) */}
                      <Box
                        onClick={() => handleExpandYear(year)}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <Typography
                          variant="h5"
                          sx={{ fontWeight: "bold", color: "#b24743" }}
                        >
                          TTT & Webinars Gallery Year {year}
                        </Typography>
                        <NavigateNextIcon
                          sx={{
                            transform:
                              expandedYear === year
                                ? "rotate(90deg)"
                                : "rotate(0deg)",
                            transition: "0.3s",
                          }}
                        />
                      </Box>

                      {/* 🔹 Expandable Event List */}
                      {expandedYear === year && (
                        <Grid container spacing={2} sx={{ padding: "10px" }}>
                          {groupedEvents[year].map((event, index) => (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={4}
                              lg={3}
                              key={index}
                              sx={{ display: "flex", justifyContent: "center" }}
                            >
                              <Paper
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  width: "280px",
                                  backgroundColor: "#fff",
                                  borderRadius: "15px",
                                  boxShadow: 5,
                                  overflow: "hidden",
                                  transition: "transform 0.3s ease-in-out",
                                  "&:hover": {
                                    transform: "scale(1.05)",
                                    boxShadow: 10,
                                  },
                                }}
                                onClick={() =>
                                  handleEventClick(event.id, event.title)
                                }
                              >
                                {/* 🟢 Event Image */}
                                <img
                                  src={
                                    event.imgSrc && event.imgSrc.trim() !== ""
                                      ? event.imgSrc
                                      : PPKMLogo
                                  }
                                  alt={event.title}
                                  style={{
                                    width: "100%",
                                    height: "180px",
                                    objectFit: "cover",
                                    borderRadius: "15px 15px 0 0",
                                  }}
                                />

                                {/* 🟢 Title Section */}
                                <Box
                                  sx={{
                                    padding: "10px",
                                    textAlign: "center",
                                    width: "100%",
                                    backgroundColor: "#f9f9f9",
                                    borderRadius: "0 0 15px 15px",
                                  }}
                                >
                                  <Typography
                                    variant="h6"
                                    sx={{
                                      fontSize: "16px",
                                      fontWeight: "bold",
                                      color: "#333",
                                      padding: "5px",
                                    }}
                                  >
                                    {event.title}
                                  </Typography>
                                </Box>
                              </Paper>
                            </Grid>
                          ))}
                        </Grid>
                      )}
                    </Paper>
                  ))
              ) : (
                // 🟢 Default rendering for other categories
                <Grid container spacing={2} sx={{ justifyContent: "center" }}>
                  {filteredgalleryListData.map((event, index) => (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      lg={3}
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Paper
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          width: "280px",
                          backgroundColor: "#fff",
                          borderRadius: "15px",
                          boxShadow: 5,
                          overflow: "hidden",
                          transition: "transform 0.3s ease-in-out",
                          "&:hover": {
                            transform: "scale(1.05)",
                            boxShadow: 10,
                          },
                        }}
                        onClick={() => handleEventClick(event.id, event.title)}
                      >
                        <img
                          src={
                            event.imgSrc && event.imgSrc.trim() !== ""
                              ? event.imgSrc
                              : PPKMLogo
                          }
                          alt={event.title}
                          style={{
                            width: "100%",
                            height: "180px",
                            objectFit: "cover",
                            borderRadius: "15px 15px 0 0",
                          }}
                        />
                        <Box
                          sx={{
                            padding: "10px",
                            textAlign: "center",
                            width: "100%",
                            backgroundColor: "#f9f9f9",
                            borderRadius: "0 0 15px 15px",
                          }}
                        >
                          <Typography
                            variant="h6"
                            sx={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              color: "#333",
                              padding: "5px",
                            }}
                          >
                            {event.title}
                          </Typography>
                        </Box>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Box>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default GalleryDetails;
